export const baseUrl = process.env.REACT_APP_BASEURL
  ? process.env.REACT_APP_BASEURL
  : `${process.env.PUBLIC_URL}`;

  